exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profilePage-profilePic {\n  width: 150px;\n  border-radius: 50%; }\n\n.edit-name input {\n  height: 70px;\n  font-size: 22px;\n  color: #757373;\n  border: 1.5px solid #ced4da;\n  padding-left: 15px; }\n\n.user-edit-button {\n  border: none;\n  margin: 10px; }\n\n.profilePage-user {\n  font-size: 19px;\n  margin-left: 30px; }\n\n.profilePage-user-name h1 {\n  display: inline-block;\n  vertical-align: middle; }\n\n.user-info p {\n  color: #666565; }\n\n#profile-photo-label {\n  display: inline;\n  text-align: center; }\n", ""]);

// exports
